"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceDisruptionRouteImpact = exports.SourceDisruptionRouteType = exports.SourceOutageType = exports.SourceAvailability = void 0;
var SourceAvailability;
(function (SourceAvailability) {
    SourceAvailability["Partial"] = "partial";
    SourceAvailability["None"] = "none";
})(SourceAvailability = exports.SourceAvailability || (exports.SourceAvailability = {}));
var SourceOutageType;
(function (SourceOutageType) {
    SourceOutageType["Outage"] = "outage";
    SourceOutageType["Disruption"] = "disruption";
})(SourceOutageType = exports.SourceOutageType || (exports.SourceOutageType = {}));
var SourceDisruptionRouteType;
(function (SourceDisruptionRouteType) {
    SourceDisruptionRouteType["Domestic"] = "domestic";
    SourceDisruptionRouteType["International"] = "international";
})(SourceDisruptionRouteType = exports.SourceDisruptionRouteType || (exports.SourceDisruptionRouteType = {}));
var SourceDisruptionRouteImpact;
(function (SourceDisruptionRouteImpact) {
    SourceDisruptionRouteImpact["Partial"] = "partial";
    SourceDisruptionRouteImpact["Total"] = "total";
})(SourceDisruptionRouteImpact = exports.SourceDisruptionRouteImpact || (exports.SourceDisruptionRouteImpact = {}));
//# sourceMappingURL=source-outages.js.map